// extracted by mini-css-extract-plugin
module.exports = {"buttonTruncate":"DataTableFacetedFilter_buttonTruncate__o0RJX"};